import { Component, OnInit } from '@angular/core';

interface Option {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss'],
})
export class BillingComponent implements OnInit {

  selected1: any;
  selected2: any;

  option1: Option[] = [
    {value: 'bill1', viewValue: 'Bill 1'},
    {value: 'bill2', viewValue: 'Bill 2'},
    {value: 'bill3', viewValue: 'Bill 3'}
  ];

  option2: Option[] = [
    {value: 'option1', viewValue: '#234242353525'},
    {value: 'option2', viewValue: '#234242353525'},
    {value: 'option3', viewValue: '#234242353525'}
  ];

  constructor() { }

  ngOnInit(): void {
    this.selected1 = 'All';
    this.selected2 = 'Product/Transaction/ID';
  }

  select1(value: any) {
    this.selected1 = value;
  }

  select2(value: any) {
    this.selected2 = value;
  }

}
